/**
 * Control scroll down + scroll up button functionality
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package OnlineGambling - Sex on Screen
 */

import { scrollTo, scrollIntoView } from 'scroll-js';
import { debounce } from 'debounce';

const scrollToX = () => {
    const scrollDown = document.getElementById('scrollDown');
    const scrollTop = document.getElementById('scrollTop');
    const main = document.getElementById('main');

    const checkScroll = () => {
        const scrollXPos = (window.pageYOffset !== undefined)
            ? window.pageYOffset
            : (document.documentElement
                || document.body.parentNode
                || document.body).scrollTop;

        if (scrollXPos > 350) {
            scrollTop.classList.add('show');
        } else {
            scrollTop.classList.remove('show');
        }
    };

    window.addEventListener('scroll', debounce(checkScroll, 150), true);

    scrollDown.addEventListener('click', () => {
        scrollIntoView(main, document.body, { behavior: 'smooth' }).then(() => {
            // console.log('scrolled down');
        });
    });

    scrollTop.addEventListener('click', () => {
        scrollTo(document.body, { top: 0, easing: 'ease-in-out' }).then(() => {
            // console.log('scrolled top');
        });
    });
};

export default scrollToX;
